module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sasa"
  }, [_c('el-dialog', {
    attrs: {
      "title": "楼层详情",
      "visible": _vm.dialogFormVisible,
      "width": "70%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "card-view",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    staticClass: "btn-black",
    on: {
      "click": _vm.shua
    }
  }, [_vm._v("\n\t\t\t\t\t\t刷新\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "legal",
      "label": "法人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "电话",
      "width": "180"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "hide-on-single-page": true,
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b6c4c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/fooldetail.vue
// module id = 887
// module chunks = 1